/* eslint-disable react/no-array-index-key */
/* eslint-disable no-console */
/* eslint-disable react/no-children-prop */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { every } from 'lodash';
import { Grid, IconButton } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { AddCircle, RemoveCircle } from '@mui/icons-material';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FormContainer from '../../../FormContainer/FormContainer';
import {
  updateFormWeightState,
  verticalSelect
} from './defaultState/defaultState';
import { handleFormObjectChange } from '../../../Utilities/HandleFormObjectChange';
import { validateForSubmit } from '../../../Utilities/ValidationHelper/ValidateForm';
import { NetworkRequest } from '../../../Utilities/NetworkRequests/NetworkRequests';
import { buildFormFieldsWithStateForm } from '../../../Utilities/formHelper';
import { colors } from '../../../../Utilities/LenoxColors';
import Dialog from '../../../Dialog';
import LoaderComponent from '../../../Utilities/LoaderComponent';
import { handleChange as updateFilters } from '../../../Filters/actions/actions';
import { logError } from '../../../../Utilities/logError';

const styles = () => ({
  tableTitle: {
    fontSize: '1.25rem',
    textAlign: 'center',
    padding: '.5rem',
    backgroundColor: colors.lenoxDark2,
    color: colors.lenoxLight1,
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
    marginBottom: '1rem'
  },
  sectionTitle: {
    fontSize: '1.1rem',
    padding: '.5rem',
    backgroundColor: colors.lenoxDark2,
    color: colors.lenoxLight1,
    margin: '1rem 5rem'
  },
  verticalsTitle: {
    padding: '0 4rem 2rem 4rem'
  },
  addForm: {
    display: 'block',
    width: '100%',
    textAlign: 'center',
    marginBottom: '-1rem',
    marginTop: '1rem'
  },
  weightedContainer: {
    position: 'relative'
  },
  automaticTestingMessage: {
    padding: '5% 10%',
    textAlign: 'center',
    color: 'rgba(0,0,0,0.54)',
    fontSize: 18
  },
  removeButton: {
    position: 'absolute',
    top: 15,
    left: 15
  }
});

const siteToVertical = {
  2: 'Auto',
  4: 'Home',
  1: 'Life',
  5: 'Medicare',
  7: 'Commercial',
  6: 'Pet',
  8: 'Health',
  9: 'FE'
};

// @TODO: Refactoring. Rewrite to hooks
class PlacementTypesForms extends Component {
  constructor(props) {
    super(props);
    const formState = () => {
      const state = updateFormWeightState();

      return {
        ...state,
        addWeight: {
          ...state.addWeight,
          render: () => this.renderAddForm()
        }
      };
    };
    this.state = {
      siteSelect: verticalSelect(),
      tyTypes: [],
      baseFormValues: { ...formState() },
      verticalsWithSettings: undefined,
      formValues: {
        types: [{ ...formState() }]
      },
      open: true,
      submitting: false,
      loading: false,
      dialog: {
        message: '',
        type: 'error',
        title: 'Error'
      },
      confirmationDialog: {
        message: '',
        type: 'confirm',
        title: 'Error'
      },
      confirmationRemoveAllDialog: {
        message: '',
        type: 'confirm',
        title: 'Error'
      }
    };
  }

  componentDidMount() {
    this.loadOptions();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.siteSelect.site.value !== prevState.siteSelect.site.value) {
      this.loadOptions();
    }
  }

  componentWillUnmount() {
    this.handleVerticalChange('site', '2');
  }

  loadOptions = async () => {
    this.setState({ loading: true });
    const { baseFormValues } = this.state;
    const { data } = await NetworkRequest(
      'reports',
      { only_active: true },
      'getTyTypes'
    );

    const options = data.map((type, idx) => ({
      value: idx.toString(),
      display: type
    }));

    this.setState({ tyTypes: options });

    if (data && data.length) {
      const newValues = {
        ...baseFormValues,
        type: {
          ...baseFormValues.type,
          options: [...options]
        }
      };

      this.setState({ baseFormValues: newValues }, () => this.loadForms());
    } else {
      this.loadForms();
    }
  };

  updateOptionsInTypes = (types, value) => {
    const newTypes = [...types];

    const baseOptions = this.state.baseFormValues.type.options;
    const selectedValues = types.map(({ type }) => type.value);
    if (value) {
      selectedValues.push(value);
    }

    newTypes.forEach(({ type }, index) => {
      const options = baseOptions.filter(
        (opt) => opt.value === type.value || !selectedValues.includes(opt.value)
      );

      newTypes[index].type.options = options;
    });

    return newTypes;
  };

  loadForms = async () => {
    const { row } = this.props;
    const { baseFormValues, siteSelect } = this.state;
    const { data } = await NetworkRequest(
      'affiliates',
      {
        affiliate_id: row.affiliate_id
      },
      'getTyPlacementTypes'
    );

    const handleFormData = (formData) => {
      return formData && formData.length > 0
        ? formData.map((type) => ({
            ...baseFormValues,
            type: {
              ...baseFormValues.type,
              value: this.state.tyTypes.find(
                (el) => el.display === type.ty_type
              ).value
            },
            weight: {
              ...baseFormValues.weight,
              value: type.weight
            },
            addWeight: {
              ...baseFormValues.addWeight,
              render: () =>
                this.state.formValues.types.length < this.state.tyTypes.length
                  ? this.renderAddForm()
                  : ''
            }
          }))
        : [
            {
              ...baseFormValues,
              type: {
                ...baseFormValues.type
              },
              weight: {
                ...baseFormValues.weight
              },
              addWeight: {
                ...baseFormValues.addWeight,
                render: () => this.renderAddForm()
              }
            }
          ];
    };

    const types = this.updateOptionsInTypes(
      handleFormData(data[siteSelect.site.value])
    );

    this.setState({
      verticalsWithSettings: data ? Object.keys(data) : undefined,
      formValues: {
        types
      },
      loading: false
    });
  };

  handleChange = (field, value, i) => {
    const sectionValues = handleFormObjectChange(field, value, {
      ...this.state.formValues.types[i]
    });
    const newFormValues = { ...this.state.formValues };
    newFormValues.types[i] = sectionValues;

    if (field === 'type') {
      newFormValues.types = this.updateOptionsInTypes(
        newFormValues.types,
        value
      );
    }

    this.setState({ formValues: newFormValues });
  };

  handleVerticalChange = (field, value) => {
    const newValues = handleFormObjectChange(field, value, {
      ...this.state.siteSelect
    });
    this.setState({ siteSelect: newValues }, this.loadOptions);
  };

  toggleDialog = (message = '', type = 'error', title = 'Error') =>
    this.setState({
      dialog: { ...this.state.dialog, message, type, title }
    });

  toggleConfirm = (message = '', type = 'confirm', title = 'Confirm Edit') =>
    this.setState({
      confirmationDialog: {
        ...this.state.confirmationDialog,
        message,
        type,
        title
      }
    });

  toggleRemoveAllConfirm = (
    message = '',
    type = 'confirm',
    title = 'Confirm Remove'
  ) =>
    this.setState({
      confirmationRemoveAllDialog: {
        ...this.state.confirmationRemoveAllDialog,
        message,
        type,
        title
      }
    });

  handleSubmit = () => {
    const validSections = [];
    let errorMessages = [];
    this.state.formValues.types.forEach((section) => {
      const { valid, messages } = validateForSubmit(section);
      validSections.push(valid);
      errorMessages = errorMessages.concat(messages);
    });
    if (!every(validSections)) {
      this.toggleDialog(errorMessages, 'error');
      return;
    }
    this.toggleConfirm(
      'Are you sure that you want to change your TY placement types?'
    );
  };

  handleReset = () => {
    this.toggleRemoveAllConfirm(
      'Are you sure that you want to remove all your TY placement types?'
    );
  };

  handleSubmitRequest = (
    endpoint,
    action,
    formValues,
    callback = null,
    title = 'Types were successfully saved.'
  ) => {
    const { row } = this.props;
    const { siteSelect } = this.state;
    this.setState({ submitting: true }, async () => {
      const submitFormValues = this.formValues(formValues);
      const params = {
        affiliate_id: row.affiliate_id,
        site_id: siteSelect.site.value,
        weight: !action.includes('delete') ? submitFormValues : null,
        action
      };

      try {
        const { data } = await NetworkRequest(endpoint, params, action);
        callback && (await callback(data));

        this.toggleDialog(
          data.success ? title : data.errors,
          data.success ? 'success' : 'error',
          data.success ? 'Success' : 'Error'
        );
      } catch (error) {
        logError(error);

        this.toggleDialog(error, 'error', 'Error');
      }

      this.setState({ submitting: false });
    });
  };

  formValues = () => {
    let submitFormValues = [];
    this.state.formValues.types.forEach(({ type, weight }) => {
      const formattedData = {};
      formattedData.weight = Number(Number(weight.value).toFixed(2)).toString();
      formattedData.ty_type = this.state.tyTypes[+type.value].display;
      submitFormValues = [formattedData, ...submitFormValues];
    });

    return submitFormValues;
  };

  addTYTypeForm = () => {
    this.setState(({ formValues, baseFormValues, tyTypes }) => {
      const baseOptions = this.state.baseFormValues.type.options;
      const selectedValues = formValues.types.map(({ type }) => type.value);
      const { value } = baseOptions.find(
        (option) => !selectedValues.includes(option.value)
      );

      const newState = {
        formValues: {
          ...formValues,
          types: [
            ...formValues.types,
            {
              ...baseFormValues,
              type: {
                ...baseFormValues.type,
                value
              },
              weight: {
                ...baseFormValues.weight
              },
              addWeight: {
                ...baseFormValues.addWeight,
                render: () =>
                  this.state.formValues.types.length < tyTypes.length
                    ? this.renderAddForm()
                    : ''
              }
            }
          ]
        }
      };

      newState.formValues.types = this.updateOptionsInTypes(
        newState.formValues.types
      );

      return newState;
    });
  };

  removeTYTypesForm = (i) =>
    this.setState(({ formValues }) => {
      const filteredTypes = formValues.types.filter((_, index) => index !== i);

      return {
        formValues: {
          types: this.updateOptionsInTypes(filteredTypes)
        }
      };
    });

  renderConfirmDialog = () => {
    return (
      !!this.state.confirmationDialog.message && (
        <Dialog
          title={this.state.confirmationDialog.title}
          children={this.state.confirmationDialog.message}
          open={!!this.state.confirmationDialog.message}
          onRequestSave={async () => {
            await this.handleSubmitRequest(
              'affiliates',
              'saveTyPlacementTypes',
              this.state.formValues,
              this.loadForms
            );
            this.toggleConfirm('');
          }}
          onRequestClose={() => setTimeout(() => this.toggleConfirm(), 300)}
          type={this.state.confirmationDialog.type}
          saveButtonText="Submit"
        />
      )
    );
  };

  renderRemoveAllDialog = () => {
    if (!this.state.confirmationRemoveAllDialog.message) {
      return null;
    }

    return (
      !!this.state.confirmationRemoveAllDialog.message && (
        <Dialog
          title={this.state.confirmationRemoveAllDialog.title}
          children={this.state.confirmationRemoveAllDialog.message}
          open={!!this.state.confirmationRemoveAllDialog.message}
          onRequestSave={async () => {
            await this.handleSubmitRequest(
              'affiliates',
              'deleteTyPlacementTypes',
              this.state.formValues,
              this.loadForms,
              'TY types were successfully removed.'
            );
            this.toggleRemoveAllConfirm('');
          }}
          onRequestClose={() =>
            setTimeout(() => this.toggleRemoveAllConfirm(''), 300)
          }
          type={this.state.confirmationRemoveAllDialog.type}
          saveButtonText="Submit"
        />
      )
    );
  };

  renderAddForm = () => {
    return (
      <div className={this.props.classes.addForm}>
        <IconButton onClick={() => this.addTYTypeForm()} size="large">
          <AddCircle />
        </IconButton>
        Add TY type
      </div>
    );
  };

  renderVerticalSelect = () => (
    <FormContainer
      formValues={buildFormFieldsWithStateForm(
        this.state.siteSelect,
        this.state.siteSelect
      )}
      handleChange={this.handleVerticalChange}
      inputWidth={8}
      separateBlock
    />
  );

  renderDeviceFormContainer = (
    handleSubmitFunc,
    handleChange,
    submitting,
    dialog,
    handleResetFunc
  ) =>
    this.state.formValues.types.map((section, i) => {
      const isLastForm = this.state.formValues.types.length - 1 === i;

      return (
        <div
          key={`${section.type.value}-${i}`}
          id={`types-weighted-type-${i}`}
          className={this.props.classes.weightedContainer}
        >
          {!(i === 0 && this.state.formValues.types.length === 1) && (
            <IconButton
              onClick={() => this.removeTYTypesForm(i)}
              className={this.props.classes.removeButton}
              size="large"
            >
              <RemoveCircle />
            </IconButton>
          )}
          <FormContainer
            formValues={buildFormFieldsWithStateForm(section, section)}
            submitting={isLastForm ? submitting : null}
            handleChange={(field, value) => handleChange(field, value, i)}
            handleSubmit={isLastForm ? handleSubmitFunc : null}
            handleReset={handleResetFunc}
            contentReset="Remove All"
            inputWidth={4}
            separateBlock
            dialog={isLastForm ? dialog : null}
            toggleDialog={this.toggleDialog}
            caption="testing"
          />
        </div>
      );
    });

  renderFormContainer = (
    handleSubmitFunc,
    handleChange,
    submitting,
    dialog,
    handleResetFunc,
    title
  ) => (
    <Grid>
      <>
        {this.state.verticalsWithSettings && (
          <div className={this.props.classes.verticalsTitle}>{title}</div>
        )}
        {this.renderVerticalSelect()}
        {this.state.loading ? (
          <LoaderComponent padding={150} />
        ) : (
          this.renderDeviceFormContainer(
            handleSubmitFunc,
            handleChange,
            submitting,
            dialog,
            handleResetFunc
          )
        )}
      </>
    </Grid>
  );

  render() {
    const { submitting, dialog } = this.state;

    const verticals = this.state.verticalsWithSettings?.map(
      (vertical) => siteToVertical[vertical]
    );
    const title = `This affiliate has settings for the following verticals: ${
      verticals && verticals.length ? verticals.join(', ') : 'None'
    }.`;

    return (
      <>
        {this.renderFormContainer(
          this.handleSubmit,
          this.handleChange,
          submitting,
          dialog,
          this.handleReset,
          title
        )}
        {this.renderConfirmDialog()}
        {this.renderRemoveAllDialog()}
      </>
    );
  }
}

export default connect(
  (state) => ({
    site: state.filters.site
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateFilters
      },
      dispatch
    )
)(withStyles(PlacementTypesForms, styles));
